__turbopack_context__.v({
  "cart-opt-in": "cart-opt-in-module-scss-module__uJ-MCG__cart-opt-in",
  "cart-opt-in-content": "cart-opt-in-module-scss-module__uJ-MCG__cart-opt-in-content",
  "content": "cart-opt-in-module-scss-module__uJ-MCG__content",
  "loader": "cart-opt-in-module-scss-module__uJ-MCG__loader",
  "opt-in-cta-button": "cart-opt-in-module-scss-module__uJ-MCG__opt-in-cta-button",
});
